export const INDOORVIEWER_PREFIX = 'iv'
export const MAPVIEW_PREFIX = 'mapview'
export const PLANVIEW_PREFIX = 'planview'
export const DASHBOARDVIEW_PREFIX = 'dashboardview'
